// 通用信息提示浮层 / Generic info modal.
// 非错误、非危险的常规提示用这个，比如"已有模拟在运行"。
// Use this for benign informational notices (e.g. "a simulation is already running").
// 遵循 AGENTS.md 的约定：点击外部不关闭，Escape 也不关闭，只能通过按钮退出。
// Per AGENTS.md: no backdrop / Escape dismiss — button-only.

export interface InfoModalOptions {
  title: string;
  message: string;
  /** 按钮文案，默认 "Got it" / Button label, defaults to "Got it". */
  acknowledge?: string;
  /** 视觉语气 / Visual tone. */
  tone?: "info" | "warn";
}

/** 弹出信息提示并在用户点击按钮后 resolve / Open an info modal; resolves when the user clicks Ack. */
export function showInfoModal(opts: InfoModalOptions): Promise<void> {
  const root = document.getElementById("info-modal");
  if (!root) throw new Error("#info-modal mount missing");

  return new Promise<void>((resolve) => {
    const tone = opts.tone ?? "info";
    const label = opts.acknowledge ?? "Got it";
    root.hidden = false;
    root.innerHTML = `
      <div class="overlay"></div>
      <div class="modal info-modal-panel tone-${tone}">
        <div class="info-modal-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor"
            stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            ${tone === "warn"
              ? `<path d="M12 2 1.5 21h21z" />
                 <line x1="12" y1="9" x2="12" y2="14" />
                 <circle cx="12" cy="17.5" r="1.1" fill="currentColor" stroke="none" />`
              : `<circle cx="12" cy="12" r="9" />
                 <line x1="12" y1="8" x2="12" y2="12.5" />
                 <circle cx="12" cy="16" r="1.1" fill="currentColor" stroke="none" />`}
          </svg>
        </div>
        <h3>${escape(opts.title)}</h3>
        <p class="info-modal-message">${escape(opts.message)}</p>
        <div class="info-modal-actions">
          <button type="button" class="button primary info-modal-ack">${escape(label)}</button>
        </div>
      </div>
    `;

    root.querySelector<HTMLButtonElement>(".info-modal-ack")
      ?.addEventListener("click", () => {
        root.hidden = true;
        root.innerHTML = "";
        resolve();
      });
  });
}

function escape(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
